import { Box, Button, Center, Flex, Heading, Stack } from "@chakra-ui/react"
import * as React from "react"
import { useRecoilValue, useSetRecoilState, useRecoilState } from "recoil"
import { Routes, Views } from "../../../constants"
import useReducedLandscapeView from "../../../hooks/useLandscapeViews"
import { brandingSelector, roomSelector } from "../../../recoil/atoms/room"
import { viewSelector } from "../../../recoil/atoms/view"
import { UserAvatar } from "../../common/avatar"
import { saveConfigAvatarAtom } from "../../../recoil/atoms/avatar"
import { getUserTypeByUrl } from "../../../util/getUserTypeByUrl"
import { UserType } from "../../../types/user"
import layoutStates from "../../../recoil/atoms/layout"
import { Logo } from "../../header/logo"
import { useTranslation } from "react-i18next"
import { isMobileDevice } from "../../../util/browser"
import useWindowSize from "../../../hooks/useWindowSize"
import { useBrowserType } from "../../../hooks/useBrowserType"
import { sessionEndPageAtom } from "../../../recoil/atoms/sessionModalData"
import { useHistory } from "react-router-dom"
import { navigatedFromShowListAtom } from "../../../recoil/atoms/shows"
import { navigatedFromAvatarsListAtom } from "../../../recoil/atoms/avatars"
import { addCurrentQueryParams } from "../../../util"

export const Bye = () => {
  const { t } = useTranslation()
  const { screenSize } = useWindowSize()
  const { isSafariMobile, isAndroid } = useBrowserType()
  const isMobile = isSafariMobile || isAndroid
  const isLandscape = screenSize.width > screenSize.height
  
  const setView = useSetRecoilState(viewSelector)
  const roomStyles = useRecoilValue(brandingSelector)
  const room = useRecoilValue(roomSelector)
  const showMinifiedLables = useReducedLandscapeView()
  const config = useRecoilValue(saveConfigAvatarAtom)
  const userTypeFromUrl = getUserTypeByUrl()
  const isModeratorType = React.useMemo(
    () => userTypeFromUrl === UserType.MODERATOR,
    [userTypeFromUrl]
    )  
  const sessionEndPage =  useRecoilValue(sessionEndPageAtom)
  const showJoinAgainButtonOnByePage = useRecoilValue(layoutStates.showJoinAgainButtonOnByePage)
  
  const isAudience = userTypeFromUrl === UserType.AUDIENCE

  const profileImageUrl = roomStyles.roomAvatarImage ?? ""
  const [showHeader, setShowHeader] = useRecoilState(layoutStates.showHeader)

  const history = useHistory()
  const navigatedFromShowList = useRecoilValue(navigatedFromShowListAtom)
  const navigatedFromAvatarsList = useRecoilValue(navigatedFromAvatarsListAtom)

  React.useEffect(() => {
    // navigate the user to /show if the user has join the room from the show screen 
    if(navigatedFromShowList) {
      setView(Views.LOADING)
      history.push(addCurrentQueryParams(Routes.SHOWS))
    }
    if (navigatedFromAvatarsList) {
      setView(Views.LOADING)
      history.replace(addCurrentQueryParams(Routes.AVATARS))
    }
  }, [navigatedFromShowList, navigatedFromAvatarsList, history, setView])

  React.useEffect(() => {
    if (room?.enableHeaderBar === true) {
      setShowHeader(true)
    }
    if (room?.enableHeaderBar === false) {
      setShowHeader(false)
    }
  }, [room?.enableHeaderBar, setShowHeader])


  // showButton if room is not expired or we have sessionEndPageCloseButtonLink
  const showButton = showJoinAgainButtonOnByePage || sessionEndPage?.sessionEndPageCloseButtonLink

  const backToHome = () => setView(Views.HOME)
  const openUserProvidedLink = () => window.open(sessionEndPage.sessionEndPageCloseButtonLink, "_self")
  const handleOnClick = sessionEndPage?.sessionEndPageCloseButtonLink ? openUserProvidedLink : backToHome

  const buttonText = sessionEndPage?.sessionEndPageCloseButtonText
    ? sessionEndPage?.sessionEndPageCloseButtonText ?? t("Open link")
    : isAudience
    ? t("Join again")
    : t("Enter again")

  return (
    <Flex
      align={"center"}
      justify={"center"}
      bgGradient="linear(to-r, orange.400,green.200)"
      bgColor={
        roomStyles?.joinPageBackgroundColor
          ? roomStyles.joinPageBackgroundColor
          : "gray.100"
      }
      bgImage={
        roomStyles?.joinPageBackgroundImage
          ? `url(${roomStyles.joinPageBackgroundImage})`
          : "none"
      }
      bgSize="cover"
      backgroundPosition="center"
      bgRepeat="no-repeat"
      left="0"
      top="64px"
      w="100%"
      h="100%"
    >
      <Stack
        spacing={isMobileDevice(screenSize) && 4}
        mx={"auto"}
        maxW={"lg"}
        py={isMobileDevice(screenSize) && 12}
        px={isMobileDevice(screenSize) && 6}
        width={
          isMobileDevice(screenSize) && !(isMobile && isLandscape) && "100%"
        }
        alignItems="center"
      >
        <Box
          rounded={"lg"}
          bg={
            roomStyles?.joinPagePanelBackgroundColor
              ? roomStyles?.joinPagePanelBackgroundColor
              : "#FFFFFF"
          }
          boxShadow={"lg"}
          p={4}
          /* width="100%" */
          maxWidth={isMobileDevice(screenSize) ? "400px" : "470px"}
          width={
            showButton
              ? "100%"
              : isMobile && isLandscape
              ? "334px"
              : isMobileDevice(screenSize)
              ? "100%"
              : "334px"
          }
          /*  minW={!isMobileDevice(screenSize)"400px" */
          borderWidth="1px"
          borderColor={
            roomStyles?.joinPagePanelBorderColor
              ? roomStyles?.joinPagePanelBorderColor
              : "transparent"
          }
        >
          {!showHeader && (
            <Flex alignItems="center" justifyContent="center">
              <Logo src={roomStyles?.roomHeaderIcon} />
            </Flex>
          )}
          <Stack spacing={"0.4rem"}>
            <Stack align={"center"}>
              <Heading
                fontSize={
                  !showMinifiedLables
                    ? "2xl"
                    : t("Bye").length > 12
                    ? "3xl"
                    : "4xl"
                }
                color={roomStyles?.joinPagePanelTextColor ?? "#000000"}
                textAlign="center"
                /* color={
                  roomStyles?.joinPagePanelSubTextColor
                    ? roomStyles?.joinPagePanelSubTextColor
                    : "#4A5568"
                } */

                opacity={"0.85"}
              >
                {sessionEndPage?.sessionEndPageTitle ?? t("Bye") + " ✋"}
              </Heading>
              <Heading
                fontSize={
                  sessionEndPage?.sessionEndPageMessage
                    ? "md"
                    : !showMinifiedLables
                    ? "2xl"
                    : "4xl"
                }
                fontWeight={sessionEndPage?.sessionEndPageMessage && "medium"}
                align={"center"}
                /* whiteSpace={!isMobileDevice(screenSize) ? "nowrap" : "unset"} */
                color={roomStyles?.joinPagePanelTextColor ?? "#000000"}
              >
                {sessionEndPage?.sessionEndPageMessage ?? room?.name}
              </Heading>
            </Stack>
            {showMinifiedLables && (
              <>
                <Center>
                  <UserAvatar
                    bg={
                      profileImageUrl !== "" && isModeratorType
                        ? "transparent"
                        : "blackAlpha.900"
                    }
                    colorDisk={"#4A5568"}
                    avatarStyle={{ width: "3rem", height: "3rem" }}
                    avatar={config}
                    src={isModeratorType && profileImageUrl}
                  />
                </Center>
              </>
            )}

            {showButton && (
              <Button
                width={
                  isMobile && isLandscape
                    ? "334px"
                    : isMobileDevice(screenSize)
                    ? "100%"
                    : "334px"
                }
                maxW={isMobileDevice(screenSize) && "334px"}
                margin={
                  !showMinifiedLables
                    ? "0.5rem auto 0px auto !important"
                    : "1rem auto 0px auto !important"
                }
                bg={
                  roomStyles?.joinButtonBackgroundColor
                    ? roomStyles?.joinButtonBackgroundColor
                    : "#1AC541"
                }
                border={
                  roomStyles?.joinButtonBorderColor
                    ? `1px solid ${
                        roomStyles?.joinButtonBorderColor
                          ? roomStyles.joinButtonBorderColor
                          : "transparent"
                      }`
                    : "0px"
                }
                textColor={
                  roomStyles?.joinPageButtonTextColor
                    ? roomStyles?.joinPageButtonTextColor
                    : "#FFFFFF"
                }
                _hover={{
                  backgroundColor:
                    roomStyles?.joinButtonMouseoverBackgroundColor
                      ? roomStyles.joinButtonMouseoverBackgroundColor
                      : "#24A840",
                  textColor: roomStyles?.joinPageButtonMouseoverTextColor
                    ? roomStyles.joinPageButtonMouseoverTextColor
                    : "#FFFFFF",
                  borderColor: roomStyles?.joinButtonBorderMouseoverColor ?? null,
                }}
                borderRadius={roomStyles?.joinButtonBorderRadius}
                onClick={handleOnClick}
                _focus={{}}
                _active={{}}
              >
                {buttonText}
              </Button>
            )}
          </Stack>
        </Box>
      </Stack>
    </Flex>
  )
}

export default Bye
